import React, { useContext } from "react";
import MessageModals from "../components/modals/MessageModals";
import Header from "../components/header/Header";
import DesktopView from "../components/desktopview/DesktopView";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import globalContext from "../Contexts/GlobalContext";

export default function InsuranceList() {
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const contextData = useContext(globalContext);
  return (
    <>
      <div className="hidden min-[1024px]:block ">
        <DesktopView />
      </div>
      <div
        className="absolute w-full top-0 bottom-0 flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden "
        onClick={() => {}}
      >
        <Header relt="relative" />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}

        <div
          className={`w-[85vw] h-full flex flex-col items-start justify-start  gap-y-[2vw] `}
        >
          <div className="w-full flex flex-col items-center justify-center p-[2vw] mt-[12vw] mb-[4vw] gap-y-[1vw]">
            <p className="font-font_primary_A text-[5.5vw] text-white font-bold">
              خدمات بیمه خودرو
            </p>
            <p className="font-font_primary_A text-[3vw] text-white font-extralight">
              ارائه دهنده بیمه خودرو خود را از لیست زیر انتخاب نمایید
            </p>
          </div>

          <div className="w-full flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A  ">
            <div
              className="relative w-full min-h-[20vw] flex items-center justify-between border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw]  px-[2vw] "
              onClick={() => {
                window.open("https://scpn.ir/bimeh");
              }}
            >
              <div className="">
                <img
                  src="../assets/images/icon/icon_bimecom.png"
                  className="w-[18vw] h-[18vw] object-contain"
                />
              </div>
              <div className="h-full   flex flex-col items-center justify-center ">
                <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                  بیمه دات کام
                </span>
                <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                  ارائه دهنده بیمه شخص ثالث و بیمه بدنه خودرو با همکاری شرکت های
                  بیمه معتبر و دارای مجوز بیمه مرکزی
                </span>
              </div>
            </div>
          </div>

          <div className="w-full flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A  ">
            <div
              className="relative w-full min-h-[20vw] flex items-center justify-between border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw]  px-[2vw] "
              onClick={() => {
                window.open("https://scpn.ir/bimebazar");
              }}
            >
              <div className="">
                <img
                  src="../assets/images/icon/icon_bimebazar.png"
                  className="w-[18vw] h-[18vw] object-contain"
                />
              </div>
              <div className="h-full   flex flex-col items-center justify-center ">
                <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                  بیمه بازار
                </span>
                <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                  ارائه دهنده بیمه شخص ثالث و بیمه بدنه خودرو با همکاری شرکت های
                  بیمه معتبر و دارای مجوز بیمه مرکزی
                </span>
              </div>
            </div>
          </div>

          <div className="w-full flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A  ">
            <div
              className="relative w-full min-h-[20vw] flex items-center justify-between border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw]  px-[2vw] "
              onClick={() => {
                window.open("https://scpn.ir/azki");
              }}
            >
              <div className="">
                <img
                  src="../assets/images/icon/icon_aski.png"
                  className="w-[18vw] h-[18vw] object-contain"
                />
              </div>
              <div className="h-full   flex flex-col items-center justify-center ">
                <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                  بیمه ازکی
                </span>
                <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                  ارائه دهنده بیمه شخص ثالث و بیمه بدنه خودرو با همکاری شرکت های
                  بیمه معتبر و دارای مجوز بیمه مرکزی
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
